import React from 'react';
import { BoxIcon } from 'lucide-react';
interface BadgeProps {
  text: string;
  icon?: BoxIcon;
  variant?: 'success' | 'neutral' | 'accent';
}
export function Badge({
  text,
  icon: Icon,
  variant = 'neutral'
}: BadgeProps) {
  const variants = {
    success: 'bg-green-100 text-[#16A34A] border-green-200',
    neutral: 'bg-gray-100 text-gray-700 border-gray-200',
    accent: 'bg-pink-50 text-[#E6007A] border-pink-100'
  };
  return <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold border ${variants[variant]}`} data-id="element-154">
      {Icon && <Icon className="w-3 h-3 mr-1.5" data-id="element-155" />}
      {text}
    </span>;
}